import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/authContext';
import { useLanguage } from '../context/languageContext';

const Header = ({ onLangChange }) => {
  const navigator = useNavigate();
  const { user } = useContext(AuthContext);
  const { language, toggleLanguage } = useLanguage();
  const [valueBtn, setValueBtn] = React.useState('Рус');

  const handleChangeLang = () => {
    const newBtn = valueBtn === 'Рус' ? 'Бел' : 'Рус';
    setValueBtn(newBtn);
    onLangChange(newBtn === 'Рус' ? 'rus' : 'bel');
  };

  return (
    <header>
      <div className="header-logo">
        <span>Telegraph</span>
      </div>
      <div className="header-btns">
        {user?.token ? (
          <>
            <button onClick={toggleLanguage}> {language === 'rus' ? 'Рус' : 'Бел'}</button>
            <button onClick={() => navigator('/')}>Создать статью</button>
            <button onClick={() => navigator('/user')}>Мой аккаунт</button>
          </>
        ) : (
          <>
            <button onClick={toggleLanguage}> {language === 'rus' ? 'Рус' : 'Бел'}</button>
            <button onClick={() => navigator('/auth/login')}>Войти</button>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
